module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticClass: "floor"
  }, [_c('h2', [_vm._v(_vm._s(_vm.dataForm.title))]), _vm._v(" "), _c('div', {
    staticClass: "floor-tabs"
  }, [_c('el-tabs', {
    attrs: {
      "type": "card"
    },
    model: {
      value: (_vm.dataForm.activeName),
      callback: function($$v) {
        _vm.$set(_vm.dataForm, "activeName", $$v)
      },
      expression: "dataForm.activeName"
    }
  }, _vm._l((_vm.dataForm.tabList), function(item, index) {
    return _c('el-tab-pane', {
      key: index,
      attrs: {
        "label": item.title,
        "name": index + ''
      }
    })
  }), 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "floor-box"
  }, [_c('div', {
    staticClass: "floor-left"
  }, [_c('div', {
    staticClass: "floor-left__top",
    style: ({
      background: _vm.dataForm.LeftBackgroundColor
    })
  }, [_c('el-row', {
    attrs: {
      "gutter": 3
    }
  }, _vm._l((_vm.dataForm.leftNavList), function(item, i) {
    return _c('el-col', {
      key: i,
      attrs: {
        "span": 8
      }
    }, [_c('div', {
      staticClass: "goods—type__link",
      style: ({
        color: _vm.dataForm.LeftFontColor
      })
    }, [_c('span', {
      on: {
        "click": function($event) {
          return _vm.toGoodsType(item)
        }
      }
    }, [_vm._v(_vm._s(item.titleName))])])])
  }), 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "floor-left__footer",
    on: {
      "click": function($event) {
        return _vm.toImg(0)
      }
    }
  }, [_c('img', {
    attrs: {
      "src": _vm.dataForm.leftImg.url
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "floor-content"
  }, _vm._l((_vm.dataForm.tabList), function(items, index) {
    return _c('div', {
      key: index,
      staticClass: "tabsBar"
    }, _vm._l((items.children), function(item, i) {
      return ((index + '') === _vm.dataForm.activeName) ? _c('mall-goods', {
        key: i,
        attrs: {
          "msg": item,
          "usage": _vm.usage,
          "showBtn": _vm.showBtn
        }
      }) : _vm._e()
    }), 1)
  }), 0), _vm._v(" "), _c('div', {
    staticClass: "floor-right"
  }, [_c('div', {
    staticClass: "floor-right__top",
    on: {
      "click": function($event) {
        return _vm.toImg(1)
      }
    }
  }, [_c('img', {
    attrs: {
      "src": _vm.dataForm.rightImg1.url
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "floor-right__footer",
    on: {
      "click": function($event) {
        return _vm.toImg(2)
      }
    }
  }, [_c('img', {
    attrs: {
      "src": _vm.dataForm.rightImg2.url
    }
  })])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@12.2.2@vue-loader/lib/template-compiler?{"id":"data-v-76c77060","hasScoped":true}!./~/_vue-loader@12.2.2@vue-loader/lib/selector.js?type=template&index=0!./src/components/plugins/floor.vue
// module id = 795
// module chunks = 0 1 3